import type { ReactNode } from "react";
import { AppHeader } from "@2skies/frontend-shared";
import { TickerPicker } from "./TickerPicker.js";

interface Props {
  symbols: string[];
  symbol: string;
  onSymbol: (symbol: string) => void;
  show0dte: boolean;
  onToggle0dte: (next: boolean) => void;
  share?: ReactNode;
}

/**
 * DeltaTape's top bar — the shared <AppHeader />. Title top-left; the primary
 * controls are the ticker picker and the left-pane-only 0DTE toggle. The toggle
 * uses the neutral-slate active state (never a data colour). Share (when
 * supplied) rides in AppHeader's own `share` slot — always last on the right.
 */
export function DeltaTapeHeader({ symbols, symbol, onSymbol, show0dte, onToggle0dte, share }: Props): JSX.Element {
  return (
    <AppHeader
      title="DeltaTape"
      primary={
        <>
          <TickerPicker symbols={symbols} value={symbol} onSelect={onSymbol} />
          <button
            type="button"
            className={`tape-toggle${show0dte ? " tape-toggle--on" : ""}`}
            aria-pressed={show0dte}
            onClick={() => onToggle0dte(!show0dte)}
          >
            0DTE overlay
          </button>
        </>
      }
      share={share}
    />
  );
}
